<template>
  <div class="row">
    <div class="col-12">
      <card class="custom-shadow-card-header">
        <div class="row content-add-btn">
          <div class="col-4" v-if="isCreate()">
            <div class="text-left">
              <button
                class="btn btn-secondary custom-shadow-btn"
                @click="openModal('create')"
              >
                <em class="fa fa-plus"></em>
                {{ $t('widgets.widget_add') }}
              </button>
            </div>
          </div>
          <div class="col-12 text-center">
            <hr />
          </div>
          <el-dialog
            v-if="isShow()"
            :title="nameAreasSelected"
            :visible.sync="modals.read"
            width="50%"
          >
            <p>
              {{ $t('common_words.selected_record_info') }}
            </p>
            <div class="card" v-if="rowData">
              <div class="card-body" v-if="rowData">
                <table class="table">
                  <tbody>
                    <tr class="shadow-sm">
                      <td>
                        <h6>
                          <strong>{{ $t('common_words.name') }}:</strong>
                        </h6>
                        {{ rowData.name }}
                      </td>
                    </tr>
                    <tr class="shadow-sm">
                      <td>
                        <h6>
                          <strong>{{ $t('common_words.module') }}:</strong>
                        </h6>
                        {{ rowData.moduleLabel }}
                      </td>
                    </tr>
                    <tr class="shadow-sm">
                      <td>
                        <h6>
                          <strong>{{ $t('common_words.component') }}:</strong>
                        </h6>
                        {{ rowData.component_name }}
                      </td>
                    </tr>
                    <tr class="shadow-sm">
                      <td>
                        <h6>
                          <strong>{{ $t('common_words.type') }}:</strong>
                        </h6>
                        {{ rowData.type }}
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
              <div class="card-footer footer-date-at" v-if="rowData">
                <p class="text-white">
                  <small
                    >{{ $t('common_words.created_on') }}:
                    {{ rowData.created_at }}</small
                  >
                </p>
              </div>
            </div>
          </el-dialog>
          <el-dialog
            v-if="isCreate()"
            :title="title"
            :visible.sync="modals.create"
          >
            <form>
              <div class="row">
                <div class="col-6">
                  <fg-input
                    ref="name"
                    type="text"
                    :label="`${$t('common_words.name')}: *`"
                    v-model="widgetForm.name"
                    v-validate="modelValidations.name"
                    name="common_words.name"
                    :error="getError('common_words.name', true)"
                  >
                  </fg-input>
                </div>
                <div class="col-6">
                  <div class="form-group has-label">
                    <label class="text-transform-none"
                      >{{ $t('common_words.module') }} *</label
                    >
                    <br />
                    <el-select
                      v-model="widgetForm.module_id"
                      class="select-primary custom-width-select shadow-sm module-sel"
                      clearable
                      filterable
                      :placeholder="$t('common_words.select_a_module')"
                      size="large"
                    >
                      <el-option
                        v-for="option in modules"
                        class="select-primary"
                        :value="option.id"
                        :label="option.name"
                        :key="option.id"
                      ></el-option>
                    </el-select>
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="col-6">
                  <fg-input
                    ref="component_name"
                    type="text"
                    :label="`${$t('common_words.component_name')}: *`"
                    v-model="widgetForm.component_name"
                    v-validate="modelValidations.component_name"
                    name="common_words.component_name"
                    :error="getError('common_words.component_name', true)"
                  >
                  </fg-input>
                </div>
                <div class="col-6">
                  <div class="form-group has-label">
                    <label class="text-transform-none"
                      >{{ $t('common_words.type') }} *</label
                    >
                    <br />
                    <el-select
                      v-model="widgetForm.type"
                      class="select-primary custom-width-select unit-rels shadow-sm"
                      clearable
                      filterable
                      :placeholder="$t('common_words.select_a_type')"
                      size="large"
                    >
                      <el-option
                        class="select-primary"
                        :label="$t('common_words.graph')"
                        value="grafica"
                      ></el-option>
                      <el-option
                        class="select-primary"
                        :label="$t('common_words.map')"
                        value="mapa"
                      ></el-option>
                      <el-option
                        class="select-primary"
                        :label="$t('widgets.widget')"
                        value="widget"
                      ></el-option>
                    </el-select>
                  </div>
                </div>
              </div>
            </form>
            <span slot="footer" class="dialog-footer">
              <button
                class="btn btn-danger custom-shadow-btn"
                @click="closeModal('create')"
              >
                {{ $t('common_words.cancel') }}</button
              >&nbsp;
              <button
                class="btn custom-btn-success custom-shadow-btn"
                @click="validate"
              >
                {{ $t('common_words.confirm') }}
              </button>
            </span>
          </el-dialog>
        </div>
        <div v-if="isIndex()">
          <div
            class="col-12 d-flex justify-content-center justify-content-sm-between flex-wrap"
          >
            <el-select
              clearable
              @clear="pagination.perPage = 10"
              class="select-default mb-3 shadow-sm"
              style="width: 200px"
              v-model="pagination.perPage"
              :placeholder="$t('common_words.per_page')"
              filterable
            >
              <el-option
                class="select-default"
                v-for="item in pagination.perPageOptions"
                :key="item"
                :label="item"
                :value="item"
              ></el-option>
            </el-select>
            <el-input
              clearable
              class="mb-3 shadow-sm"
              style="width: 200px"
              :placeholder="$t('common_words.search_records')"
              v-model="searchQuery"
              aria-controls="datatables"
            />
          </div>
          <div class="col-sm-12">
            <el-table
              stripe
              :default-sort="{ prop: 'name', order: 'descending' }"
              :data="queriedData"
              style="width: 100%"
              :border="true"
            >
              <el-table-column
                type="index"
                width="80"
                :align="'center'"
                :resizable="false"
              ></el-table-column>
              <el-table-column
                v-for="column in tableColumns"
                :key="column.label"
                :min-width="column.minWidth"
                :prop="column.prop"
                :label="column.label"
                :fixed="column.fixed"
                :sortable="column.sortable"
                :align="column.align"
                :resizable="false"
              ></el-table-column>
              <el-table-column
                :min-width="110"
                :label="$t('common_words.operations')"
                fixed="right"
                :resizable="false"
              >
                <template slot-scope="props">
                  <div class="text-center">
                    <a
                      v-if="isShow()"
                      v-tooltip.top-center="$t('common_words.view')"
                      class="btn-info btn-simple btn-link custom-margin-actions"
                      @click="handleView(props.$index, props.row)"
                    >
                      <em class="fa fa-eye custom-size-fa-actions"></em>
                    </a>
                    <a
                      v-if="isUpdate()"
                      v-tooltip.top-center="$t('common_words.edit')"
                      class="btn-warning btn-simple btn-link custom-margin-actions"
                      @click="handleEdit(props.$index, props.row)"
                    >
                      <em class="fa fa-edit custom-size-fa-actions"></em>
                    </a>
                    <a
                      v-if="isDelete()"
                      v-tooltip.top-center="$t('common_words.erase')"
                      class="btn-danger btn-simple btn-link custom-margin-actions"
                      @click="handleDelete(props.$index, props.row)"
                    >
                      <em class="fa fa-times custom-size-fa-actions"></em>
                    </a>
                  </div>
                </template>
              </el-table-column>
            </el-table>
          </div>
        </div>
        <div v-else>
          <br />
          <h5 class="text-muted text-center">
            {{ $t('common_words.no_permissions') }}
          </h5>
        </div>
        <div
          slot="footer"
          class="col-12 d-flex justify-content-center justify-content-sm-between flex-wrap"
        >
          <div class>
            <p class="card-category">
              {{ $t('table2.showing') }} {{ from + 1 }} {{ $t('table2.a') }}
              {{ to }} {{ $t('table2.of') }} {{ total }}
              {{ $t('table2.entries') }}
            </p>
          </div>
          <l-pagination
            class="pagination-no-border"
            v-model="pagination.currentPage"
            :per-page="pagination.perPage"
            :total="pagination.total"
            pageFirst="false"
            pageLast="false"
          ></l-pagination>
        </div>
      </card>
      <div class="row" style="padding-right: 13px; padding-left: 13px">
        <div class="col-6" v-if="isPDF()">
          <div class="text-right">
            <button
              class="btn btn-danger custom-shadow-btn"
              @click="exportToPDF"
            >
              <em class="fa fa-file-pdf-o"></em>
              {{ $t('common_words.export_to_pdf') }}
            </button>
          </div>
        </div>
        <div class="col-6" v-if="isExcel()">
          <div class="text-left">
            <button
              class="btn custom-btn-success custom-shadow-btn"
              @click="exportToExcel"
            >
              <em class="fa fa-file-excel-o"></em>
              {{ $t('common_words.export_to_excel') }}
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import mixinMasters from 'src/util/mixinMasters';
import MixinPermissions from 'src/util/mixinPermissions';
import { MixinExport } from 'src/mixins/mixin-export';
import MixinForm from 'src/mixins/forms/mixin-form';
import configTable from './widgetTable';
import moment from 'moment';
import SweetAlert from 'src/class/Alerts';
import { Axios } from 'src/class/Axios.js';
import MixinMenu from 'src/util/mixinMenu';
import i18n from 'src/i18n';

export default {
  computed: {
    ...configTable().Search,
  },

  data() {
    return {
      widgetForm: {
        name: null,
        component_name: null,
        type: null,
        module_id: null,
      },
      modelValidations: {
        name: {
          required: true,
        },
        component_name: {
          required: true,
        },
        type: {
          required: true,
        },
      },
      modules: [],
      Table: {},
      Search: {},
      pagination: {},
      tableColumns: [],
    };
  },

  mixins: [mixinMasters, MixinForm, MixinPermissions, MixinExport, MixinMenu],

  watch: {
    '$i18n.locale': 'setupTable',
  },

  methods: {
    openModal(name) {
      if (name == 'create') {
        this.title = i18n.t('widgets.widget_add');
        this.$validator.reset();
        this.widgetForm = {
          name: null,
          component_name: null,
          type: null,
          module_id: null,
        };
      }
      this.modals[name] = true;
    },

    validate() {
      return this.$validator.validateAll().then((isValid) => {
        if (isValid) {
          if (!this.widgetForm.module_id) {
            this.highlightItem('module-sel');
            return false;
          } else if (!this.widgetForm.type) {
            this.highlightItem('type-sel');
            return false;
          } else {
            this.addEditWidget();
          }
        }
      });
    },

    handleView(index, row) {
      this.rowData = row;
      this.rowData.created_at = moment(
        String(this.rowData.created_at),
        'YYYY-MM-DD HH:mm:ss'
      ).format('YYYY-MM-DD hh:mm:ss');
      this.modals['read'] = true;
    },

    handleEdit(index, row) {
      this.title = i18n.t('widgets.widget_edit') + ' ' + row.name;
      this.widgetForm = Object.assign({}, row);
      this.widgetForm.route = 'widgets/user';
      this.errors.clear();
      this.modals['create'] = true;
    },

    handleDelete(index, row) {
      this.widgetForm = row;
      SweetAlert.delete(
        i18n.t('widgets.the_widget') + ' ' + this.widgetForm.name
      ).then((result) => {
        if (result.value) this.deleteWidget();
      });
    },

    addEditWidget() {
      this.showHideLoading(true);
      if (this.widgetForm.route == 'widgets/user') {
        if (this.isUpdate()) {
          Axios.updateMaster(this.widgetForm)
            .then((response) =>
              this.modifyTable(1, this.widgetForm.id, response)
            )
            .catch((error) => this.showMessageErrors(error));
        } else {
          this.showMessageAccess();
          this.showHideLoading();
        }
      } else {
        this.widgetForm.route = 'widgets/user';
        if (this.isCreate()) {
          Axios.saveMaster(this.widgetForm)
            .then((response) =>
              this.modifyTable(0, this.widgetForm.id, response)
            )
            .catch((error) => this.showMessageErrors(error));
        } else {
          this.showMessageAccess();
          this.showHideLoading();
        }
      }
    },

    deleteWidget() {
      if (this.isDelete()) {
        this.showHideLoading(true);
        this.widgetForm.route = 'widgets/user';
        Axios.destroyMaster(this.widgetForm)
          .then((response) => this.modifyTable(2, this.widgetForm.id, response))
          .catch((error) => this.showMessageErrors(error));
      } else {
        this.showMessageAccess();
      }
    },

    exportToPDF() {
      let data = {};
      data.route = 'widgets/pdf';
      data.name_file = 'widgets.pdf';
      this.PDF(data)
        .then(() => {
          this.showDownloadNotification();
        })
        .catch((error) => this.showMessageErrors(error));
    },

    exportToExcel() {
      let data = {};
      data.route = 'widgets/excel';
      data.name_file = 'widgets.xlsx';
      this.Excel(data)
        .then(() => {
          this.showDownloadNotification();
        })
        .catch((error) => this.showMessageErrors(error));
    },
    setupTable() {
      const { Table, Search } = configTable();
      this.Table = Table;
      this.Search = Search;
      this.tableColumns = Table.tableColumns;
      this.pagination = Table.pagination;
    },
  },

  created() {
    if (this.isIndex()) {
      this.setupTable();
      this.showHideLoading(true);
      Axios.getMasters('widgets/user')
        .then((response) => {
          this.tableData = response.data.data;
          this.searchFuse(
            this.tableColumns.map((prop) => {
              return prop.prop;
            })
          );
          this.showHideLoading();
        })
        .catch((error) => this.showMessageErrors(error));
      Axios.getMasters('modules/indexfield')
        .then((response) => (this.modules = response.data.data))
        .catch((error) => this.showMessageErrors(error));
    } else {
      this.showHideLoading();
    }
  },

  mounted() {
    this.selectedItemOnMenu('widgets');
  },

  destroyed() {
    this.deselectedItemOnMenu('widgets');
  },
};
</script>
